import * as Yup from 'yup';

const CancellationReasonSchema = Yup.object().shape({
	reason: Yup.string().required('Select an option before continuing'),
});

export default CancellationReasonSchema;
